module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBanner),
      expression: "isBanner"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "35%"
    },
    attrs: {
      "label": "角色名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.jsName),
      callback: function($$v) {
        _vm.jsName = $$v
      },
      expression: "jsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "35%"
    },
    attrs: {
      "label": "是否启用："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.caozuo),
      callback: function($$v) {
        _vm.caozuo = $$v
      },
      expression: "caozuo"
    }
  }, _vm._l((_vm.caozuoarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("角色管理")]), _vm._v(" "), (_vm.authority.indexOf('add') > -1) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger",
      "data-btnmark": "add"
    },
    on: {
      "click": function($event) {
        return _vm.showAddedit('')
      }
    }
  }, [_vm._v("+ 新增")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.users,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleid",
      "label": "角色ID",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.roleid))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rolename",
      "label": "角色名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.rolename))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "描述",
      "align": "center",
      "width": "230"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.remark))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.isenabled == 1 ? '否' : '是'
          }
        }, [_vm._v(_vm._s(scope.row.isenabled == 1 ? '否' : '是'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operatorname",
      "label": "操作人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.operatorname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operatetime",
      "label": "操作时间",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.operatetime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "220",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.authority.indexOf('edit') > -1) ? _c('span', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "edit"
          },
          on: {
            "click": function($event) {
              return _vm.showAddedit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('setright') > -1) ? _c('span', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "setright"
          },
          on: {
            "click": function($event) {
              return _vm.showAuthor(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-cog",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" 权限设置\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('enabledordisable') > -1) ? _c('span', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "enabledordisable"
          },
          on: {
            "click": function($event) {
              return _vm.cardStatus(scope.row)
            }
          }
        }, [_c('i', {
          class: scope.row.isenabled == 0 ? 'el-icon-circle-close' : 'el-icon-circle-check'
        }), _vm._v("\r\n                " + _vm._s(scope.row.isenabled == 0 ? "禁用" : "启用") + "\r\n              ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdd),
      expression: "isAdd"
    }],
    staticClass: "add_banner pad_left"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("角色管理详情")])]), _vm._v(" "), _c('el-form', {
    ref: "editForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名称：",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.roleName),
      callback: function($$v) {
        _vm.roleName = $$v
      },
      expression: "roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描　　述：",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticClass: "textarea",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "textarea",
      "rows": "3"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelBan()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showBan()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAuthor),
      expression: "isAuthor"
    }],
    staticClass: "main_container pad_left",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("角色管理权限设置")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "block table_container"
  }, [_c('div', {
    staticClass: "top_desc_contianer"
  }, [_c('div', {
    staticClass: "table_container role_type"
  }, [_vm._v("角色名称：" + _vm._s(_vm.tempRole.rolename))]), _vm._v(" "), _c('div', {
    staticClass: "table_container role_desc"
  }, [_vm._v("角色描述：" + _vm._s(_vm.tempRole.remark))]), _vm._v(" "), _c('div', {
    staticClass: "table_container role_auth"
  }, [_vm._v("禁用：" + _vm._s(_vm.tempRole.roletype == 1 ? '否' : '是'))])]), _vm._v(" "), _c('div', {
    staticClass: "top_desc_contianer title"
  }, [_c('div', {
    staticClass: "table_container role_type"
  }, [_vm._v("功能模块")]), _vm._v(" "), _c('div', {
    staticClass: "table_container role_auth"
  }, [_vm._v("操作权限")])]), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    staticClass: "tree_data lineheighttree",
    attrs: {
      "data": _vm.menudata,
      "show-checkbox": "",
      "node-key": "menuid",
      "default-expand-all": "",
      "expand-on-click-node": false,
      "props": _vm.defaultProps,
      "default-checked-keys": _vm.alreadyChoose
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('div', {
          staticClass: "custom-tree-node",
          staticStyle: {
            "width": "100%",
            "height": "auto"
          }
        }, [_c('span', {
          staticClass: "left_tree",
          staticStyle: {
            "display": "inline-block"
          }
        }, [_vm._v(_vm._s(node.label))]), _vm._v(" "), _c('span', {
          staticClass: "right_action"
        }, [_c('div', {
          staticClass: "el-checkbox-group"
        }, _vm._l((data.buttons), function(item, index) {
          return _c('el-checkbox', {
            key: index,
            attrs: {
              "label": item.menuid,
              "checked": item.ischecked == 1
            },
            on: {
              "change": function (e) { return _vm.changeBox(index, data, e); }
            }
          }, [_vm._v(_vm._s(item.menuname))])
        }), 1)])])
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 10px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancle()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.saveSeting()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重 置")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bdcc973!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/role.vue
// module id = 1635
// module chunks = 3